<template>
    <div>
        <b-alert variant="primary" show class="mb-0">
            <h5>
                <font-awesome-icon
                    icon="fa-duotone fa-handshake"
                    class="mr-1"
                />
                {{ $t("How Requests Work") }}
            </h5>
            <div>
                {{
                    $t(
                        "Send credits to a creator in exchange for a custom request. They'll see your request and the price you're offering. If they accept and complete it, the credits are transferred to their wallet"
                    )
                }}
            </div>

            <h5 class="mt-3">
                <font-awesome-icon
                    icon="fa-duotone fa-clock-rotate-left"
                    class="mr-1"
                />
                {{ $t("What If They Don't Complete the Request?") }}
            </h5>
            <div>
                {{
                    $t(
                        "Creators have 1 week to complete a pending request. If they don't, the credits are automatically refunded to your wallet"
                    )
                }}
            </div>

            <h5 class="mt-3">
                <font-awesome-icon
                    icon="fa-duotone fa-shield-check"
                    class="mr-1"
                />
                {{ $t("What Is the Authenticity Code?") }}
            </h5>
            <div>
                {{
                    $t(
                        "An optional unique code the creator includes in their content, usually by showing it in their photo or video, so you know it's original, genuine, and made just for you. We recommend requiring the code on every request"
                    )
                }}
            </div>

            <h5 class="mt-3">
                <font-awesome-icon
                    icon="fa-duotone fa-thumbs-down"
                    class="mr-1"
                />
                {{ $t("What If I'm Not Satisfied?") }}
            </h5>
            <div>
                {{
                    $t(
                        "You can open a dispute, which gives the creator a chance to correct their submission. If you still don't get what you're looking for, you'll be refunded"
                    )
                }}
            </div>

            <h5 class="mt-3">
                <font-awesome-icon
                    icon="fa-duotone fa-hourglass-half"
                    class="mr-1"
                />
                {{ $t("Content Is Available for") }}
                {{ config.creatorRequestRetentionDays }}
                {{ $t("Days") }}
            </h5>
            <div>
                {{ $t("Completed request content stays available for") }}
                {{ config.creatorRequestRetentionDays }}
                {{
                    $t(
                        "days, then it's automatically removed. If you want to keep it, download it before it expires"
                    )
                }}
            </div>

            <b-btn
                variant="primary"
                @click="hideInfo"
                pill
                class="mt-3"
                block
                size="lg"
            >
                {{ $t("Continue") }}
            </b-btn>
        </b-alert>
    </div>
</template>

<script>
import { mapState } from "vuex";

export default {
    computed: {
        ...mapState("options", ["config"]),
    },
    methods: {
        async hideInfo() {
            await this.api.post("/userFlag/guideHowRequestWorksFinished");
            this.$store.dispatch("onboarding/status");
        },
    },
};
</script>
